import styled from '@emotion/styled';
import {colors} from 'ui/config';
import mask from 'assets/img/mask.png';
import img from 'assets/img/mousse.png';

export const LoginBackground = styled('div')({
  backgroundImage: `url(${img})`,
  minHeight: ['100vh', '100dvh'],
  width: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundColor: colors.darkBrown,
});

export const LoginMask = styled('div')({
  backgroundImage: `url(${mask})`,
  minHeight: ['100vh', '100dvh'],
  width: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
});
